export default __webpack_public_path__ + "static/media/maps-me.a7dfcbb5.svg";